import React from "react";
import {Button} from "react-bootstrap";

interface FeedbackButtonsProps {
    handleClickFeedbackButtons: (isFound: boolean) => void;
    isManualFeedbackProvided: boolean;
    t: (key: string) => string;
}

export const FeedbackButtons: React.FC<FeedbackButtonsProps> = ({
                                                                    handleClickFeedbackButtons,
                                                                    isManualFeedbackProvided,
                                                                    t
                                                                }) => (
    <div className="d-flex justify-content-end">
        <Button variant="danger" onClick={() => handleClickFeedbackButtons(false)}
                disabled={isManualFeedbackProvided} className="me-2">
            {t("ExtractedImages.ManualNotFoundButton")}
        </Button>
        <Button variant="success" onClick={() => handleClickFeedbackButtons(true)}
                disabled={isManualFeedbackProvided}>
            {t("ExtractedImages.ManualFoundButton")}
        </Button>
    </div>
);
